<template>
  <span
    class="status-badge"
    :class="`status-badge--${active ? 'active' : 'inactive'}`"
  >
    <a-icon :type="active ? 'check-circle' : 'minus-circle'" theme="filled" />
    {{ label }}
  </span>
</template>

<script>
// Badge de status genérico (ícone + rótulo colorido) extraído para shared/ porque
// se repete entre módulos. Aceita rótulo livre ("Ativa/Inativa", "Ativo/Inativo")
// para não amarrar o texto ao domínio.
export default {
  name: "StatusBadge",
  props: {
    label: { type: String, required: true },
    active: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;

  &--active {
    color: @color-success;
  }

  &--inactive {
    color: @color-text-muted;
  }
}
</style>
